export interface ParametroReporte {
    parametro: Parametro;
    alias: string;
    descripcion: string;
    valorXDefecto?: string;
    valor?: string[];
    orden: number;
    requerido: boolean;
    multipleValor?: boolean;
    parametroLista?: ParametroLista;
}
export interface Parametro {
    uuid: string;
    nombre: string;
    tipoParametro: TipoParametro;
}

export interface ParametroLista {
    uuid: string;
    nombre: string;
    origen?: string;
    valores?: string[];
    tipoParametro: TipoParametro;
}

export enum TipoParametro {
    string = "STRING",
    number = "INT64",
    date = "DATE",
    boolean = "BOOL"
}